<template>
  <el-dialog
    v-if="formData"
    :visible.sync="dialogVisible"
    custom-class="form-dialog"
    :append-to-body="true"
    :title="$t('shopDecoration.multimediaMaterial.addGroup')"
  >
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      label-width="100px"
      v-if="dialogVisible"
    >
      <el-form-item label="标题" prop="groupName">
        <el-input
          v-model="formData.groupName"
          :maxlength="50"
          show-word-limit
        ></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="close">
        {{ $t('shopDecoration.home.controls.cancel') }}
      </el-button>
      <el-button type="primary" @click="confirm">
        {{ $t('common.confirm') }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import editDialog from '@/mixins/edit-dialog';

export default {
  components: {},
  mixins: [editDialog],
  props: {
    materialType: {
      type: Number,
      required: true,
    },
    editItem: {
      type: Object,
      required: true,
    },
    editId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      formData: null,
      rules: {
        groupName: {
          type: 'string',
          required: true,
          trigger: 'blur',
          message: this.$t(
            'shopDecoration.multimediaMaterial.materialNameRequired'
          ),
        },
      },
    };
  },
  watch: {
    editItem: {
      handler(v) {
        this.formData = _.cloneDeep(v);
      },
      immediate: true,
    },
  },
  methods: {
    confirm() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        //  this.editId
        this.$http
          .post('/materialGroup/save', {
            ...this.formData,
            type: this.materialType,
            parentId: this.editId,
          })
          .then(res => {
            if (res.data.success) {
              this.$message.success('保存成功！');
              this.$emit('edited');
              this.close();
            } else {
              this.$message.warning(res.data.message);
            }
          });
      });
    },
    handleEditedShop() {
      this.$emit('edited');
    },
  },
};
</script>
<style lang="scss" scoped></style>
